import {useContext} from "react";
import {ChatContext} from "./chatContext";

const useChats = () => useContext(ChatContext);

export default useChats;
